import { Component, Inject, OnDestroy, OnInit, Output, EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { InfoService } from '@app/core/info/info.service';
import { ConsentsService } from '../consents.service';
import { IConsentElement } from '@app/certificates/consents/consent';
import { takeUntil } from 'rxjs/operators';
import { ISpringResponseBody } from '@app/shared/interfaces/response-interfaces';

@Component({
  selector: 'cloud-revoke-consent',
  templateUrl: './revoke-consent.component.html',
  styleUrls: ['./revoke-consent.component.scss'],
})
export class RevokeConsentComponent implements OnDestroy {

  @Output() close: EventEmitter<any> = new EventEmitter();

  private lang: string;
  private unsubscribe$: Subject<void> = new Subject<void>();
  data: IConsentElement;
  revokeReason: string;

  constructor(
    private translateService: TranslateService,
    private info: InfoService,
    private consentService: ConsentsService,
    @Inject(MAT_DIALOG_DATA) data
  ) {
    this.data = data;
    this.lang = this.translateService.currentLang;
  }

  revoke() {
    if (!this.revokeReason) {
      this.info.error('consentsTexts.enterRevokeReason');
    } else {
      this.consentService.updateConsent(this.data, this.revokeReason)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((res: ISpringResponseBody) => {
          if (res.status === 200) {
            this.info.success('consentsTexts.revokeSuccess');
            this.closeDialog(this.revokeReason);
          } else {
            this.info.error('consentsTexts.revokeError');
          }
        });
    }
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  closeDialog(revokeReason) {
    this.close.emit(revokeReason);
  }
}
